import React from 'react';
import { Modal, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Card } from '@material-ui/core/';
import { Body_data } from '../constant';
import Footer from './Footer';
import Timeline from './Timeline';

class Body extends React.Component{
    state={
        open: false
    }
    openToggle=()=>{
        this.setState({open:!this.state.open});
    }
    render(){
        return (
            <>
            <Modal style={{marginLeft:'27%'}} open={this.state.open} onClose={this.openToggle}>
                <div style={{width:'60%', backgroundColor:'#fff', height:'400px', borderRadius:'20px'}}>
                <center>
                    <h1>{Body_data.modal.heading}</h1>
                    <p>{Body_data.modal.body_info}</p>
                </center>
                </div>
            </Modal>
            <div className="row load2">
                <div className="col-md-8">
                <div className="row">
                    <div className="col-md-12">
                    <h3><i className="fas fa-user" aria-hidden="true"></i>{'  '+Body_data.heading}</h3>
                        <table className="load3" style={{width:'100%'}}>
                            <tbody>
                            <tr style={{ background:'#feb236',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-envelope" aria-hidden="true"></i></td><td>E- mail: </td><td>{Body_data.about.email}</td></tr>
                            <tr style={{ background:'#ff7b25',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-phone" aria-hidden="true"></i></td><td>Phone no.: </td><td>{Body_data.about.phone}</td></tr>
                            <tr style={{ background:'#feb236',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-male" aria-hidden="true"></i></td><td>Gender: </td><td>{Body_data.about.gender} </td></tr>
                            <tr style={{ background:'#ff7b25',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-map-marker" aria-hidden="true"></i></td><td>Hometown location: </td><td><a href={Body_data.about.hometown.link}>{Body_data.about.hometown.place}</a> </td></tr>
                            <tr style={{ background:'#feb236',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-globe" aria-hidden="true"></i></td><td>Current location : </td><td><a href={Body_data.about.current.link}>{Body_data.about.current.place}</a> </td></tr>
                            <tr style={{ background:'#ff7b25',width:'80%', height:'30px', fontSize:'16px' }}><td style={{padding:'10px'}}><i className="fa fa-globe" aria-hidden="true"></i></td><td>Nationality: </td><td>{Body_data.about.nationality} </td></tr>
                            </tbody>
                        </table>
                        </div>
                        <div className="col-md-12">
                            <h3><i className="fa fa-certificate" aria-hidden="true"></i>{'  '+Body_data.certifications.heading}</h3>
                            <div className="row">
                            <ExpansionPanel className="col-md-5">
                                <ExpansionPanelSummary expandIcon={<i className="fa fa-chevron-down" aria-hidden="true"></i>}><i style={{marginRight:'10px'}} className="fa fa-university" aria-hidden="true"></i>Professional</ExpansionPanelSummary>
                                <ExpansionPanelDetails style={{height:'100%'}}>
                                    <div className="container">
                                        {
                                            Body_data.certifications.professional.map((data,i)=>(
                                                <Card key={i} style={{marginTop:'10px', width:'250px', height:'100px', textOverflow:'hidden', overflow:'ellipse'}}>
                                                    <p style={{textAlign:'center', marginTop:'7px'}}>
                                                        Issued By: {data.organization}<br />
                                                        Course: {data.course}<br />
                                                        Remarks: {data.remarks}<br />
                                                        Dated: {data.dated}</p>
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            <ExpansionPanel style={{marginLeft:'2%'}} className="col-md-5">
                                <ExpansionPanelSummary expandIcon={<i className="fa fa-chevron-down" aria-hidden="true"></i>}><i style={{marginRight:'10px'}} className="fa fa-university" aria-hidden="true"></i>Extracurricular</ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                <div className="container">
                                        {
                                            Body_data.certifications.extra.map((data,i)=>(
                                                <Card key={i} style={{marginTop:'10px', width:'250px', height:'100px', textOverflow:'hidden', overflow:'ellipse'}}>
                                                    <p style={{textAlign:'center', marginTop:'7px'}}>
                                                        Issued By: {data.organization}<br />
                                                        Course: {data.course}<br />
                                                        Remarks: {data.remarks}<br />
                                                        Dated: {data.dated}</p>
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            </div>
                            <div style={{marginTop:'10px'}} className="row">
                            <ExpansionPanel className="col-md-5">
                                <ExpansionPanelSummary expandIcon={<i className="fa fa-chevron-down" aria-hidden="true"></i>}><i style={{marginRight:'10px'}} className="fa fa-university" aria-hidden="true"></i>Academics</ExpansionPanelSummary>
                                <ExpansionPanelDetails style={{height:'100%'}}>
                                    <div className="container">
                                        {
                                            Body_data.certifications.academics.map((data,i)=>(
                                                <Card key={i} style={{marginTop:'10px', width:'250px', height:'100px', textOverflow:'hidden', overflow:'ellipse'}}>
                                                    <p>
                                                        School:{data.school}<br />
                                                        Board:{data.board}<br />
                                                        Course:{data.course}<br />
                                                        {/* Marks/Grades:{data.marks} */}
                                                    </p>
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            <ExpansionPanel style={{marginLeft:'2%'}} className="col-md-5">
                                <ExpansionPanelSummary expandIcon={<i className="fa fa-chevron-down" aria-hidden="true"></i>}><i style={{marginRight:'10px'}} className="fa fa-university" aria-hidden="true"></i>Internships and Work Experience</ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                <div className="container">
                                        {
                                            Body_data.certifications.internship.map((data,i)=>(
                                                <Card key={i} style={{marginTop:'10px', width:'250px', height:'100px', textOverflow:'hidden', overflow:'ellipse'}}>
                                                    <p>
                                                        Company/Organization:{data.company}<br />
                                                        Technology used:{data.technology}<br />
                                                        Duration:{data.dates}
                                                    </p>
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            </div><br />
                            <h3><i className="fa fa-id-card" aria-hidden="true"></i>{'  '+Body_data.other_involvements.heading}</h3>
                            <div style={{marginTop:'10px'}} className="row">
                                <div className="col-md-9">
                                    <ul>
                                        {
                                            Body_data.other_involvements.list.map((text,i)=>(
                                                <li key={i}>{text.text}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                </div>
                <div className="col-md-8">
                    <Footer Body_data={Body_data} />
                </div>
                </div>
                <div style={{backgroundColor:'#40e6bf'}} className="col-sm-4">
                    <Timeline Body_data={Body_data.school} />
                </div>
            </div>
            </>
        )
    }
}

export default Body;